import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { ProfileStatistics } from '../models';

export const profileStatisticsActions = createActionGroup({
    source: 'Profile Statistics',
    events: {
        'Get Profile Statistics': emptyProps(),
        'Get Profile Statistics Success': props<{ payload: ProfileStatistics }>(),
        'Get Profile Statistics Error': props<{ code: number }>(),
        Clear: emptyProps(),
    },
});
